import { render, staticRenderFns } from "./ProductEditSection.vue?vue&type=template&id=135c35b2&"
import script from "./ProductEditSection.vue?vue&type=script&lang=ts&"
export * from "./ProductEditSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports